var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNothingToShowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-nothing-to-show"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5108",
    "data-name": "Rectangle 5108",
    width: 26,
    height: 29,
    transform: "translate(0.453 0.066)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98370",
    "data-name": "Group 98370",
    transform: "translate(-809 -351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26608",
    "data-name": "Group 26608",
    transform: "translate(71 -2859)",
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5103",
    "data-name": "Rectangle 5103",
    width: 48,
    height: 48,
    rx: 24,
    transform: "translate(738 3210)",
    fill: "#29325b",
    opacity: 0.11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26618",
    "data-name": "Group 26618",
    transform: "translate(819.766 360.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26613",
    "data-name": "Group 26613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26612",
    "data-name": "Group 26612",
    clipPath: "url(#clip-path-nothing-to-show)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62241",
    "data-name": "Path 62241",
    d: "M153.059,179.184l-5.2,5.2a7.755,7.755,0,0,1,4.5.346c.447.155,1.194-.592,1.039-1.039a7.751,7.751,0,0,1-.346-4.5",
    transform: "translate(-135.791 -164.554)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62242",
    "data-name": "Path 62242",
    d: "M14.575,45.887a8.083,8.083,0,1,1,0,11.431,8.088,8.088,0,0,1,0-11.431",
    transform: "translate(-11.212 -39.968)",
    fill: "#8e94f3",
    fillRule: "evenodd",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26615",
    "data-name": "Group 26615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26620",
    "data-name": "Group 26620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62244",
    "data-name": "Path 62244",
    d: "M2.862,34.174a9.063,9.063,0,1,1,0,12.816,9.067,9.067,0,0,1,0-12.816M3.9,35.213a7.593,7.593,0,1,1,0,10.739,7.6,7.6,0,0,1,0-10.739",
    transform: "translate(-0.192 -28.948)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62245",
    "data-name": "Path 62245",
    d: "M1.15,44.614A9.065,9.065,0,0,1,12.672,32.183c.023.3.036.6.036.912q0,.356-.022.707A7.595,7.595,0,0,0,2.767,44.507a11.672,11.672,0,0,1-1.578.107Z",
    transform: "translate(-0.191 -28.949)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62246",
    "data-name": "Path 62246",
    d: "M190.9,225.332a2.2,2.2,0,0,1,3.118-3.117l7.1,7.1c.191.191-.352,1.045-1.212,1.905s-1.714,1.4-1.905,1.212Z",
    transform: "translate(-174.722 -203.479)",
    fill: "#040227",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26617",
    "data-name": "Group 26617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26619",
    "data-name": "Group 26619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62247",
    "data-name": "Path 62247",
    d: "M190.9,225.332a2.2,2.2,0,0,1,3.118-3.117l6.427,6.427c.191.191-.352,1.045-1.213,1.9s-1.714,1.4-1.9,1.213Z",
    transform: "translate(-174.722 -203.479)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62248",
    "data-name": "Path 62248",
    d: "M87.448,98.868a1.161,1.161,0,0,1,.435-1.007,1.069,1.069,0,0,1,1.406.088,1.046,1.046,0,0,1,.236.7,2.377,2.377,0,0,1-.66,1.569,3.7,3.7,0,0,0-.94,2.188.49.49,0,0,0,.979.053,2.791,2.791,0,0,1,.742-1.649,3.279,3.279,0,0,0,.858-2.168A2,2,0,0,0,90.02,97.3a2.07,2.07,0,0,0-2.719-.226,2.1,2.1,0,0,0-.833,1.819.49.49,0,0,0,.98-.023",
    transform: "translate(-79.407 -88.776)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62249",
    "data-name": "Path 62249",
    d: "M103.576,181.4a.6.6,0,1,1-.6-.6.6.6,0,0,1,.6.6",
    transform: "translate(-94.013 -166.039)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62250",
    "data-name": "Path 62250",
    d: "M207.493,4.088l1.47-2.449a.49.49,0,1,0-.84-.5l-1.47,2.449a.49.49,0,1,0,.84.5",
    transform: "translate(-189.716 -0.824)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62251",
    "data-name": "Path 62251",
    d: "M237.364,5.7l5.389-3.919a.49.49,0,0,0-.576-.793l-5.389,3.919a.49.49,0,1,0,.576.793",
    transform: "translate(-217.27 -0.826)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62252",
    "data-name": "Path 62252",
    d: "M249.194,74.842l3.919-.98a.49.49,0,1,0-.238-.95l-3.919.98a.49.49,0,0,0,.238.95",
    transform: "translate(-228.289 -66.945)",
    fill: "#040227",
    fillRule: "evenodd"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingToShowIcon);
export default __webpack_public_path__ + "static/media/nothing-to-show-icon.ff8999d484c0785fc8ebe8cd4243e927.svg";
export { ForwardRef as ReactComponent };